<div class="account-pages my-5 pt-sm-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card overflow-hidden">
                    <div class="bg-soft bg-primary">
                        <div class="text-danger p-2 text-center">
                            <div class=" fs-1"><i _ngcontent-bjy-c358="" class="bx bxs-lock"></i></div>
                            <h3>Access to this page is restricted</h3>
                            <p>Please check with the site admin if you believe this is a mistake.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- end container -->
</div>
<!-- end page -->